import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { id: "appointment-form-app-mobile" } },
    [
      _vm.$slots["club-screen"]
        ? _c(
            "div",
            { staticClass: "appointment-page-wrapper px-2 pt-2 pb-6" },
            [_vm._t("club-screen")],
            2
          )
        : _vm.$slots["state-screen-flat"]
        ? _vm._t("state-screen-flat")
        : _vm.$slots["state-screen"]
        ? _c(
            "div",
            { staticClass: "appointment-page-wrapper px-2 pt-2 pb-6" },
            [_vm._t("state-screen")],
            2
          )
        : _c(
            "div",
            {
              staticClass:
                "appointment-page-wrapper layout-mobile-content px-2 pt-2 pb-6 gr-6",
            },
            [_vm._t("title"), _vm._v(" "), _vm._t("main-content")],
            2
          ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }